import { render, staticRenderFns } from "./injury-card.vue?vue&type=template&id=79f1f04e&scoped=true"
import script from "./injury-card.vue?vue&type=script&lang=js"
export * from "./injury-card.vue?vue&type=script&lang=js"
import style0 from "./injury-card.vue?vue&type=style&index=0&id=79f1f04e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f1f04e",
  null
  
)

export default component.exports